var jscHasCartJS = function() {
  return typeof CartJS !== 'undefined';
};

var jscDispatchCartChange = function() {
  document.dispatchEvent(new CustomEvent('on:cart:change', {
    bubbles: true,
    cancelable: false
  }));
};

var jscCartRequest = function(url, body) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(body)
  }).then(function(response) {
    return response.json().then(function(data) {
      if (data.status || !response.ok) {
        throw new Error(data.description || data.message || ('HTTP error! Status: ' + response.status));
      }

      return data;
    });
  }).then(function(data) {
    jscDispatchCartChange();
    return data;
  }).catch(function(error) {
    console.log(error);
  });
};

var jscCartAdd = function(vid, qty, obj) {
  return jscCartRequest('/cart/add.js', {
    items: [{
      id: Number(vid),
      quantity: Number(qty) || 1,
      properties: obj || {}
    }]
  });
};

var jscCartChange = function(id, qty, obj) {
  var body = {
    id: id,
    quantity: Number(qty) || 0
  };

  if (obj !== undefined) {
    body.properties = obj;
  }

  return jscCartRequest('/cart/change.js', body);
};

$(function(){
  applyDiscount();
  removeDiscount();
  addGift();
  removeGift();
  addGWP();
  removeGWP();
  // countdownTimer();
  // carousel();
  // carousel_textWithImage();
  onloadSubsription();
  geotargetly_loaded();
  scroll_Top();
  changeSplitIt();

  
});

var url = window.location.href;

onloadSubsription = () =>{
  var subs_toggle = $('._show_desc.active');
  var subs_title = subs_toggle.attr('data-title');
  var subs_theme = subs_toggle.attr('data-theme');

  // product title
  $('.subs-product-title .title').text(subs_title);
  // theme name
  $('.subs-theme-name .theme').text(subs_theme);
  // paywhirl price divide by num of box
  $('._pywhirl_price').each(function(){
    var vid = $(this).attr('data-vid');
    var box = $(this).attr('meta_box');
    var price_per = parseInt($(this).attr('pw-price') / box);

    if (price_per > 0) {
      var format_price_per = Shopify.formatMoney(price_per, $('body').data('money-format'));
    }
      $('._appendPerBox').each(function(){
        var _vid = $(this).attr('data-vid');
        if (vid == _vid) {
          if (url.includes('sophie-toffee')) {
            var priceCent = (price_per / 100).toFixed(2);
            $(this).html('$' + priceCent);
          } else {
            $(this).text(format_price_per);
          }
          
        }
    });

    //to calculate price difference between one month product & months product
    var price_per_subscription = price_per * box
    // var month_prod = $('.monthProdPrice').val();
    // var month_prod_times_box = month_prod * box;
    // var price_diff = month_prod_times_box - price_per_subscription;
    // var format_price_per_subscription = Shopify.formatMoney(price_diff, $('body').data('money-format'));

    $('._appendPerBox1').each(function(){     
      var _vid = $(this).attr('data-vid');
      if (vid == _vid) {
        var original_price = $(this).parents('.subs_subtotal_list').find('.monthProdPrice').val();
        var month_prod = original_price;
        var month_prod_times_box = month_prod * box;
        var price_diff = month_prod_times_box - price_per_subscription;
        var format_price_per_subscription = Shopify.formatMoney(price_diff, $('body').data('money-format'));

        console.log(original_price,price_diff,url);
        if (url.includes('sophie-toffee')) {
          var price_cent = (price_diff / 100).toFixed(2);
          $(this).html('$' + price_cent);
        } else {
          $(this).text(format_price_per_subscription);
        }
        

      }
    });

  });
  var v_id = $('._show_desc.active').attr('data-vid');
  $('._subsReview').each(function(){
    var id = $(this).attr('data-v-id');
    //console.log(id,v_id);

    setTimeout(() => {
      $(this).hide();
      if (v_id == id) {
        $(this).show();
      }
    }, 3000);
  });

  setTimeout(function() {
    $('._subsReviewWidget').each(function(i){

      var id = $(this).attr('data-v-id');
      //setTimeout(() => {}, 2000);


        $(this).hide();
        if (v_id == id) {
          // console.log(i);
          if (i === 0) { //to solve redundant review widget > show only first loop
            $('.pf_jsc_append-review-widget-subscription').append($(this));
            $('.pf_jsc_append-review-widget-subscription .okendo-widget').show();
            $(this).addClass('active');
          }

          // $(this).show();
        }

    });
    hideEmptyReviewSection();
  },3000)
}

showDesc = (e, vid) =>{
  var $_this = $(e);
  var $_title = $_this.attr('data-title');
  var $_theme = $_this.attr('data-theme');

  // product title
  $('.subs-product-title .title').text($_title);
  // theme name
  $('.subs-theme-name .theme').text($_theme);
  // change background color
  $('._show_desc').removeClass('active');
  $_this.addClass('active');

  $('._subslist').each(function(){
    var id = $(this).attr('data-vid');
    $(this).hide();
    if (id == vid) {
      $(this).show();
    }
  });
  //show star review according to product selection
  $('._subsReview').each(function(){
    var id = $(this).attr('data-v-id');
    $(this).hide();
    if (id == vid) {
      $(this).show();
    }
  });

  $('._subsReviewWidget').each(function(i){

      var id = $(this).attr('data-v-id');
      // $(this).hide();
      $(this).removeClass('active');
      if (id == vid) {  //console.log(id,'to show');
        // console.log(i);
        // console.log($('._subsReviewWidget.active').length);
        if ($('._subsReviewWidget.active').length < 2) { //to solve redundant review widget > show only first loop
          // $(this).addClass('active');
          // $('.pf_jsc_append-review-widget-subscription').append($(this));
          // $(this).parents('.pf_jsc_append-review-widget-subscription').find('._subsReviewWidget.active').show();
        }

      }

  });
}

function geotargetly_loaded(){
  // var country_code = geotargetly_country_code().toLowerCase();
  // var continent_name = geotargetly_continent_name();
  // var country_name = geotargetly_country_name();
  calculateCountryFreeDelivery();
  // showContinentName(continent_name,country_name);
}

calculateCountryFreeDelivery = () =>{
  if ($('#freedelivery_minspend').length === 0) {
    return;
  }

  var _leftPrice = 0;
  var _totSubscPrice = 0;
  // var _val = country;
  var _sgMinPrice = parseInt($('#freedelivery_minspend').attr('minprice-sgd'));
  var _rowMinPrice = parseInt($('#freedelivery_minspend').attr('minprice-usd'));
  var _aud = parseInt($('#freedelivery_minspend').attr('minprice-aud'));
  var _cad = parseInt($('#freedelivery_minspend').attr('minprice-cad'));
  var _eur = parseInt($('#freedelivery_minspend').attr('minprice-eur'));
  var _gbp = parseInt($('#freedelivery_minspend').attr('minprice-gbp'));
  // console.log('test');
  $.when($.getJSON('/cart.js', function(cart) {
    _totalPrice = cart.total_price;
    _cartItems = cart.items;
  })).then(function(){

    // Exclude subscription product price
    for (var i = 0; i < _cartItems.length; i++) {
      var $subsInCart = _cartItems[i].properties['_Subscription_Product'];

      if ($subsInCart) {
        var _price = _cartItems[i].line_price;
        _totSubscPrice += +(_price);
      }
    }

    // Final cart price after minus subsription product price
    var _finalCartPrice = _totalPrice - _totSubscPrice;

    // Calculate min amount for free delivery
    // if (_val == 'sg') {
    //   _leftPrice = _sgMinPrice - _finalCartPrice;
    //   console.log('singapore');

    //   if (_leftPrice <= 0) {
    //     $('.text_left').hide();
    //     $('.text_right').show();
    //   }else {
    //     $('.text_right').hide();
    //     $('.text_left').show();
    //     $('#_amtleft').text(Shopify.formatMoney(_leftPrice, $('body').data('money-format')));
    //   }
    // }
    // else {
      if ($('#getCurrSymbol').text().includes('AUD')) {
        _rowMinPrice = _aud;
      }
      if ($('#getCurrSymbol').text().includes('CAD')) {
        _rowMinPrice = _cad;
      }
      if ($('#getCurrSymbol').text().includes('EUR')) {
        _rowMinPrice = _eur;
      }
      if ($('#getCurrSymbol').text().includes('GBP')) {
        _rowMinPrice = _gbp;
      }
      if ($('#getCurrSymbol').text().includes('SGD')) {
        _rowMinPrice = _sgMinPrice;
      }

      console.log($('#getCurrSymbol').text(),_rowMinPrice);
      _leftPrice = _rowMinPrice - _finalCartPrice;

      if (_leftPrice <= 0) {
        $('.text_left').hide();
        $('.text_right').show();
      }else {
        $('.text_right').hide();
        $('.text_left').show();
        $('#_amtleft').text(Shopify.formatMoney(_leftPrice, $('body').data('money-format')));
      }
    //  }

  });
}

showContinentName = (continent,country) => {
  console.log(continent,',',country);
  if (continent == "Europe") {
    $('.shipping-cont').show();
  }
  else{
    $('.shipping-cont').hide();
  }
}

// carousel = () =>{
//   setTimeout(() => $(".product-recommendations .owl-carousel").on('initialized.owl.carousel', () => {
//       if (window.okeWidgetApi) {
//         window.okeWidgetApi.initAllWidgets('cfb3b5c6-adbd-45f9-83af-959fc1c930e3');
//       }
//     }).owlCarousel(
//     {items:5,
//       // margin: 35,
//       center: false,
//       responsiveClass:true,
//       responsive:{
//           0:{
//               items:2,
//               nav:true
//           },
//           600:{
//               items:4,
//               nav:true
//           },
//           1000:{
//               items:5,
//               nav:true,
//               nav:true
//           }
//       }
//     })
//     , 2000);
// }

// carousel_textWithImage = () =>{
//   var noOfGrid = $('#grid_jsc').val();

//   setTimeout(() => $(".jsc-owl-carousel .owl-carousel").owlCarousel(
//     {items:noOfGrid,
//       loop: true,
//       center: false,
//       responsiveClass:true,
//       responsive:{
//           0:{
//               items:2,
//               nav:true,
//               margin: 20,
//               center: true,
//           },
//           600:{
//               items:noOfGrid,
//               nav:true
//           }
//       }
//     })
//     , 0);
// }

// prevFunction = (e) =>{
//   //e comes from 'this'; unique to its element
//   //it will find any parent class with jsc-carousel and find owl-prev that comes from the default carousel nav
//   var owl = $(e).parents(".jsc-carousel").find(".owl-prev");

//   // Go to the previous item
//   owl.click();
//   console.log('prev carousel');
// }
// nextFunction = (e) =>{
//   //it will find any parent class with jsc-carousel and find owl-prev that comes from the default carousel nav
//   var owl = $(e).parents(".jsc-carousel").find(".owl-next");

//   // Go to the next item
//   owl.click();
//   console.log('next carousel');
// }

cartJSAddQuery = (evt, vid, qty, obj) => {
  if (!jscHasCartJS()) {
    return jscCartAdd(vid, qty, obj);
  }

  // Cart js add item, success callback, error callback

  CartJS.addItem(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          console.log('success',location.pathname);
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) =>{
  if (!jscHasCartJS()) {
    return jscCartChange(vid, qty, obj);
  }

  CartJS.updateItemById(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          console.log('success',location.pathname);
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

//Start Discount (Script Editor app)
applyDiscount = (isDrawer) =>{
  var $inputField = $('.jsc-discount');//class in snippet

    if ($inputField.length > 0){
    $inputField.each(function(){
      var $this = $(this);
      var $discountVal = $this.val();
      var $message = $this.attr('data-msg');
      var $key = $this.attr('data-key');
      var $qty = $this.attr('data-qty');
      // var $_customerTag = $this.attr('data-tag');
      // Get previous line item properties and assign them
      var $property = $this.attr('data-properties');
      var $object = $.parseJSON($property);

      $object['_discount-value-off'] = $discountVal;
      $object['_Message'] = $message;
      $object['_Discount'] = 'true';
      // $object['_Customer-tag'] = $_customerTag;

      cartJSUpdateQuery($key, $qty, $object, isDrawer );
    });
  }
}

removeDiscount = () =>{
  var $inputField = $('.jsc-remove_discount');

  $inputField.each(function(){
    var $this = $(this);
    var $key = $this.attr('data-key');
    var $qty = $this.attr('data-qty');
    // Get previous line item properties and assign them
    var $property = $this.attr('data-properties');
    var $object = $.parseJSON($property);

    if (jscHasCartJS()) {
      CartJS.updateItemById($key, $qty, $object);
    } else {
      jscCartChange($key, $qty, $object);
    }
  });
  if ($inputField.length > 0 && jscHasCartJS()) {
    $(document).on('cart.requestComplete', function(event, cart) {
      location.reload();
    });
  }
}
//End Discount (Script Editor app)

//Start gwp

addGift = () =>{
  var $inputField = $('#jsc-add-gwp');//class in snippet
  var $inputFieldupt = $('#jsc-update-gwp');

    if ($inputField.length > 0){

      var $obj = {};
      var $_vid = $inputField.val();

      $obj['Campaign'] = 'Gift';

      if (jscHasCartJS()) {
        CartJS.addItem($_vid, 1, $obj,
        {
          // Define a success callback to display a success message.
          "success": function(data, textStatus, jqXHR) {
            console.log("addGift");
          },
          // Define an error callback to display an error message.
          "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", errorThrown);
          }
        });

        $(document).on('cart.requestComplete', function(event, cart) {
          location.reload();
        });
      } else {
        jscCartAdd($_vid, 1, $obj);
      }


  }

  if ($inputFieldupt.length > 0) {

    console.log('updtGift');

    var $objupt = {};
    var $_vidupt = $inputFieldupt.val();

    $objupt['Campaign'] = 'Gift';
    console.log($objupt);
    console.log($_vidupt);

    if (jscHasCartJS()) {
      CartJS.updateItemById($_vidupt, 1, {},
      {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
          console.log("updtGift");
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log("Error occur !", errorThrown);
        }
      });

      $(document).on('cart.requestComplete', function(event, cart) {
        location.reload();
      });
    } else {
      jscCartChange($_vidupt, 1, {});
    }

  }

}

removeGift = () =>{
  var $removeGift = $('.jsc-remove-gwp');
  $removeGift.each(function(){
    var $_this = $(this);
    var $_vid = $_this.val();

    if (jscHasCartJS()) {
      CartJS.updateItemById($_vid, 0);

      $(document).on('cart.requestComplete', function(event, cart) {
        location.reload();
      });
    } else {
      jscCartChange($_vid, 0);
    }
  });
}

addGWP = () =>{
  $.when($.getJSON('/cart.js', function(cart) {

  })).then(function(cart){
    var $gwpcart_product = {};
    var $ele = $('.jsc-hidden-add-gwp');
    var $promoArray = [];

    // if there are GWP product properties then get the promo number
    for (var i = 0; i < cart.items.length; i++) {
      var $promo = cart.items[i].properties._GWP_Promo;
      if ($promo != undefined) {
        $promoArray.push($promo);
      }
    }

    $ele.each(function() {
      var $vid = parseInt($(this).val());
      var $promoNo = $(this).attr('data-promo');
      var $qty = parseInt($(this).attr('data-qty'));
      $gwpcart_product['_GWP_Promo'] = $promoNo;
      $gwpcart_product['_GWP'] = "true";

      if ($(this).length > 0) {
        if ($promoArray.includes($promoNo)) {
          // if initially is in cart then Update
          cartJSUpdateQuery($vid,$qty,$gwpcart_product);
        } else {
          // if initially not in cart then Add
          cartJSAddQuery(null, $vid, $qty, $gwpcart_product);
        }
      }
    });
  });
  if ($('.jsc-hidden-add-gwp').length > 0 && jscHasCartJS()) {
    $(document).on('cart.requestComplete', function(event, cart) {
      location.reload();
    });
  }
}

removeGWP = () =>{
  var $ele = $('.jsc-hidden-remove-gwp');

  $ele.each(function(){
    var $this = $(this);
    var $_vid = $this.val();

    if ($this.length > 0) {
      if (jscHasCartJS()) {
        CartJS.updateItemById($_vid, 0);
      } else {
        jscCartChange($_vid, 0);
      }
    }
  });
  if ($ele.length > 0 && jscHasCartJS()) {
    $(document).on('cart.requestComplete', function(event, cart) {
      location.reload();
    });
  }
}

//End gwp

//start days countdown
countdownTimer = () =>{
  // Set the date we're counting down to
  var eta = $('#eta_date').attr('data-date');
  var countDownDate = new Date(eta).getTime();

  // Update the count down every 1 second
  var x = setInterval(function() {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var extra_days = days + 1;
    // console.log(extra_days);
    // Output the result in an element with id="demo"
    // document.getElementById("shipDays").innerHTML = extra_days + " ";

    //If the count down is over, write some text
      if (distance < 0) {
        clearInterval(x);
        // document.getElementById("shipDays").innerHTML = "EXPIRED";
      }
    }, 1000);
}
//end days countdown

//open/close dropdown description
dropdown = (evt) =>{
  var dropdownContent = $(evt).next();
  dropdownContent.toggle();

  var element = $(evt).find("#ddown")
   element.toggleClass("change-ddown");
   // console.log(element);
}

//cart drawer
jscATC = (e, vid) =>{
  var $form = $(e).parents('form');
  theme.applyAjaxToProductForm($form);
}

scroll_Top = () =>{
  var scroll = $('#footer_newsletter_signup');
  if (scroll.length === 0 || !scroll.attr('action')) {
    return;
  }

  var chall = scroll.attr('action').split('#'); //returns an array
  var challenge = chall[0];
  // console.log(challenge);
  scroll.attr('action',challenge);
}

overlayCart = () => {
  var $html = `<div class="jsc-page-loading">
                  <div class="jsc-spinner-container">
                    <div class="jsc-spinner"></div>
                  </div>
                </div>`;
    $('.cart-item-list__body').prepend($html);

}

//Start: swap SplitIt icon in footer
changeSplitIt = () => {

  setInterval(function() {

    var newIcon = $('#upstream_messaging_footer_banner img').attr("src","https://cdn.shopify.com/s/files/1/0555/5273/7467/files/Payment-05.png?v=1655374218");

  },1000)

}
//end: swap SplitIt icon in footer

anchorReviewWidget = () => {

  $('html, body').animate({
    scrollTop: $('.pf_jsc_append-review-widget-subscription:visible:first').offset().top
  }, 1000);

}

hideEmptyReviewSection = () => {
  var $el = $('.pf_jsc_append-review-widget-subscription');

  // Make sure it exists
  if (!$el.length) return;

  // Check if the element is empty (no children + no text)
  if ($el.children().length === 0 && $.trim($el.text()).length === 0) {
    
    // Go up 6 parent levels
    var $parent = $el;
    for (var i = 0; i < 6; i++) {
      $parent = $parent.parent();
    }

    // Hide the entire parent block
    $parent.hide();
  }
}
